

exports.__esModule = true;
exports.$SidebarWalletRoute = undefined;

var _squid = require('squid');

var _route = require('xo-wallet-components/src/confirm-upop/route');

require('./directive');

var $SidebarWalletRoute = exports.$SidebarWalletRoute = _squid.$ComponentRoute.extend('$SidebarWalletRoute', {
    path: 'wallet',
    directive: 'xo-wallet',
    titleContent: 'asideHeader.wallet',
    trackingData: {
        fptiState: 'funding_option_selection',
        templateName: 'fundingInstruments.dust',
        pageGoal: 'Change Instruments',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-wallet-fundingsources',
                'pagename2': '%::fullpage-wallet-fundingsources:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    params: {
        padToggleFeature: null
    },
    children: [{
        route: _route.$xoConfirmUpopRoute,
        attributes: {
            token: 'token',
            phone: 'phone',
            cardmodel: 'cardModel'
        }
    }]
});

angular.value("$SidebarWalletRoute", $SidebarWalletRoute);
_squid.$ComponentRoute;

_route.$xoConfirmUpopRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-wallet/route.js
// module id = ./pages/xo-wallet/route.js
// module chunks = 0